const questions = [
    {
        id: 1,
        title: 'Jaké typy filmů najdu na Netflixu?',
        info: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Illo vitae dolores doloremque facilis a earum error dignissimos modi possimus harum.'
    },
    {
        id: 2,
        title: 'Jak se na Netflix přihlásím?',
        info: 'Consectetur adipisicing elit. Illo vitae dolores doloremque facilis a earum error dignissimos modi possimus harum, iste, accusantium numquam magni excepturi maiores rem molestiae in maxime.'
    },
    {
        id: 3,
        title: 'Kolik stojí měsíční členství na Netflixu?',
        info: 'Sit amet, consectetur adipisicing elit. Illo vitae dolores doloremque facilis a earum error dignissimos modi possimus harum.'
    },
    {
        id: 4,
        title: 'Jak často Netflix přidává nové filmy?',
        info: 'Iste, accusantium numquam magni excepturi maiores rem molestiae in maxime.'
    },
]

export default questions
